import React, { useEffect } from 'react';
import { useSelector, useDispatch, batch } from 'react-redux';

import { useMediaQuery } from '@common/hooks';
import ProblemStat from '@profile/ui/ProblemStat';
import ProfileInfo from '@profile/ui/ProfileInfo';
import ProfilePerformance from '@profile/ui/ProfilePerformance';
import ProfileSidebar, { ToggleProfile } from '@profile/ui/ProfileSidebar';
import { AchievementSection } from '@profile/ui/AchievementSection';
import { withProfileTranslations } from '@profile/hoc';
import {
  getLocale,
  getAchievements,
} from '@profile/store/achievementSection';
// import MentorSection from '@profile/ui/MentorSection';

function PrivateProfile({
  performance,
  socialProfiles,
  topicStats,
  userDetails,
  profileACL,
}) {
  const dispatch = useDispatch();
  const { tablet } = useMediaQuery();
  const { username, profile_page_hidden: profilePageHidden } = userDetails;
  const currentURL = window.location.href.endsWith('/')
    ? window.location.href : `${window.location.href}/`;
  const achievementState = useSelector(state => state.achievementSection);

  useEffect(() => {
    if (!profileACL.isPrivate()) return;
    batch(() => {
      dispatch(getAchievements());
      dispatch(getLocale());
    });
  }, [dispatch, profileACL]);

  const profilePageURL = currentURL.includes(username)
    ? currentURL : `${currentURL}${username}/`;

  function viewAsUI() {
    if (profileACL.isMentor()
        || profileACL.isPublic()) {
      return null;
    }

    return (
      <div className="profile-viewas">
        <p className="profile-viewas__text">
          Your Academy Profile stats are visible to your mentor, TA, and
          career coaches at all times.
        </p>
        <div className="profile-viewas__links">
          <a
            className="profile-viewas__link"
            href={profilePageURL}
            onClick={() => window.trackGaEvent(
              'ProfilePage',
              'Banner',
              'ViewAs',
            )}
            target="_blank"
            rel="noopener noreferrer"
          >
            View as others.
            {' >'}
          </a>
        </div>
      </div>
    );
  }

  function sidebarUI() {
    if (tablet) {
      return null;
    }

    return (
      <ProfileSidebar
        userDetails={userDetails}
        socialProfiles={socialProfiles}
        profileLink={profilePageURL}
        profileACL={profileACL}
      />
    );
  }

  function profileUI() {
    if (!tablet) {
      return null;
    }

    return (
      <div>
        <ProfileInfo
          userDetails={userDetails}
          socialProfiles={socialProfiles}
        />
        {(profileACL.isPrivate())
          ? <ToggleProfile column={false} defaultOpen={!profilePageHidden} />
          : null}
      </div>

    );
  }

  return (
    <div className="profile-layout">
      {sidebarUI()}
      <div className="profile-content">
        {viewAsUI()}
        {profileUI()}
        {achievementState.achievements.length > 0
        && profileACL.isPrivate() && <AchievementSection />}
        <ProfilePerformance
          performance={performance}
          profileACL={profileACL}
        />
        {/* <MentorSection /> */}
        <ProblemStat
          topicStats={topicStats}
          profileACL={profileACL}
        />
      </div>
    </div>
  );
}

export default withProfileTranslations(
  `/modules/academy/mentee/referral/psp_milestone_nudge`,
  'invite-friends',
)(PrivateProfile);
